module.exports = __webpack_public_path__ + "static/media/img-excl-living-suite.e287e081.jpg";